import { useLocation } from 'react-router-dom'
import { useSessionStore } from '@/stores'
import type { MomentKey } from '@/types'
import { pageFromPath } from '../utils/portalNav'
import { resolveMoment } from '../utils/sectionsConfig'
import { expectedPageMoment, stepSnapshotForPath } from '../utils/stepSnapshots'
import { usePortalNavPending } from './usePortalNavPending'

export function usePortalStep(): { session: any; moment: MomentKey; ready: boolean } {
  const pending = usePortalNavPending()
  const live = useSessionStore(s => s.session)
  const { pathname } = useLocation()
  if (!pending) {
    return { session: live, moment: resolveMoment(live), ready: true }
  }
  const snapshot = stepSnapshotForPath(pathname)
  return {
    session: snapshot ?? live,
    moment: expectedPageMoment(pageFromPath(pathname), pathname) ?? resolveMoment(live),
    ready: !!snapshot,
  }
}
